<p-panelMenu class="sidebar-panel-menu" [multiple]="isMultipleTabOpen" [model]="items"></p-panelMenu>
<div class="version-section-in-sidebar" [title]="buildVersion">
  {{buildVersion}}
</div>
<div class="powered-by-section">
  <div class="col-12 wrapper">
    <div>
      <a [href]="poweredByRedirectUrl" target="_blank">
        <img src="/assets/images/temp/powered-by-logo.png">
      </a>
    </div>
  </div>
</div>